let handleCollectionItem = {
    init(){
      this.handleRestockAlertsBtn()
      this.windowResize()
      this.handleColorSwatchPosition()
      this.setLang()

  
      $(document).on('click','.boost-pfs-filter-option-title,.boost-pfs-filter-option-item.boost-pfs-filter-option-label',function(event){
        $('.boost-pfs-filter-option-title').show()
      })

      
  
      // 快速加购选择
      $(document).on('DOMNodeInserted',".nt_select_qs1[data-opname='size'] .nt_name_current.user_choose_js", function(e) {
        // console.log('element now contains: ' + $(e.target).html());
        let _val = $(e.target).html()
        let _element = $('.nt_select_qs1[data-opname="size"] .swatch_pr_item[data-escape="'+_val+'"]')
        if (_element.hasClass('nt_soldout')) {
          $('.current-select .js_current_status').text('Sold Out').css({
            "fontSize":"12px"
          })
        }else{
          $('.current-select .js_current_status').text('')
        }
    });
  
  
      // 移动端生成clearall按钮
      // $('.boost-pfs-filter-tree-mobile-button').click(function(){
      //   if (window.innerWidth<=768&&$('.mb-filter-clear-all').length<=0&&window.location.href.indexOf('pf_')!=-1) {
      //     console.log('生成按钮')
      //     let str = `
      //         <button aria-label="Clear all filters" class="mb-filter-clear-all boost-pfs-filter-button boost-pfs-filter-clear-all" style="">Clear All</button>
      //         `
      //     $('.boost-pfs-filter-mobile-footer').prepend(str)
      //   }
      // })
      $(document).on('click','.boost-pfs-filter-tree-mobile-button',function(){
        // $(this).addClass('custom-button-fade')
        // setTimeout(() => {
        //   $(this).removeClass('custom-button-fade')
        // }, 100);
        $('.boost-pfs-filter-tree').addClass('custom-open')
        $('.boost-pfs-filter-option-content').show()
        $('.boost-pfs-filter-option-title').addClass('active')
      })
      $(document).on('click','.boost-pfs-filter-close',function(){
        $('.boost-pfs-filter-tree').addClass('slideOutRight')
        setTimeout(() => {
          $('.boost-pfs-filter-tree').removeClass('custom-open slideOutRight')
        }, 400);
      })
  
  
      $(document).on('click','.mb-filter-clear-all',function(){
        $('.boost-pfs-filter-pc.boost-pfs-filter-refine-by .boost-pfs-filter-button.boost-pfs-filter-clear-all').trigger('click')
        $('.boost-pfs-filter-option-content').hide()
      })
    },

    // 修改商品图例位置
    handleColorSwatchPosition(){
      let itemImageLen = $('.boost-pfs-filter-product-item-image').length - 1;
      let _product_img_hei = $(`.boost-pfs-filter-product-item-image:eq(${itemImageLen})`).height()
      $('.boost-pfs-filter-item-swatch-option-color, .boost-pfs-filter-item-swatch-optioncolor').css({
        "top": _product_img_hei - $('.boost-pfs-filter-item-swatch-option-color, .boost-pfs-filter-item-swatch-optioncolor').height() - 6
      }).show()
    },
    // 处理缺货商品option
    handleRestockAlertsBtn(){
      let product_img_hei = $('.boost-pfs-filter-product-item-image').height() - 40
  
      if (product_img_hei>0) {
        $('head').append('<style>.restock-alerts-notify-button{top:'+product_img_hei+'px !important}</style>')
      }
    },
    // 配置插图
    handleInsertPicture(){
      // 找到pf_代表，collection页面选择了筛选项,有筛选项则不添加插图
      if (window.location.href.indexOf('pf_')!=-1 || window.location.href.indexOf('search')!=-1) { return false }
  
      // 不是第一页则不添加插图
      let _posi = collection_custom_json.position-1
      console.log(this.getUrlParam('page'))
      if (this.getUrlParam('page')>=2) {
        return false;
      }
      let _hei = $('.boost-pfs-filter-product-item-image').height()
      $('.boost-pfs-filter-product-item').eq(_posi).before(`
        <img class="collection_pic" style="height:${_hei}px" src="${collection_custom_json.img}" />
      `)
    },
    getUrlParam(name) {
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      },
    windowResize(){
      window.addEventListener('resize', () => { 
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
        handleCollectionItem.handleColorSwatchPosition()
        if ($('.collection_pic')) {
          let _hei = $('.boost-pfs-filter-product-item-image').height()
          $('.collection_pic').css('height',_hei +'px')
        }
      });
    },
    showPop(btn){
      let clicked_ed_js = 'clicked_ed_js',
          ntid = btn.attr('data-id'),
          href = btn.attr('data-href');
      let a = (href.indexOf('?variant=') > -1 || href.indexOf('&variant=') > -1) ? '&' : '/?';
      let res = null
  
      if (sp_nt_storage) {
          res = sessionStorage.getItem('qs' + ntid)
      }
  
      if (res !== null) {
        btn.addClass('loading ' + clicked_ed_js);
        if ($.magnificPopup.instance.isOpen) {
            $.magnificPopup.close();
            setTimeout(function() {
              handleCollectionItem.quickshop_js(false, res, btn, ntid, href)
            }, $.magnificPopup.instance.st.removalDelay + 10)
        } else {
          handleCollectionItem.quickshop_js(false, res, btn, ntid, href)
        }
      }else{
        $.ajax({
          beforeSend: function() {
              btn.addClass('loading ' + clicked_ed_js)
          },
          url: href + a + 'view=quick_shop',
          success: function(data) {
              if ($.magnificPopup.instance.isOpen) {
                  $.magnificPopup.close();
                  setTimeout(function() {
                    handleCollectionItem.quickshop_js(true, data, btn, ntid, href)
                  }, $.magnificPopup.instance.st.removalDelay + 10)
              } else {
                handleCollectionItem.quickshop_js(true, data, btn, ntid, href)
              }
          },
          complete: function() {
              $('.loader').remove();
              btn.removeClass('loading')
          }
        })
      }
    },
    quickshop_js(bl, dt, btn, ntid, href){
      let clicked_ed_js = 'clicked_ed_js'
      $.magnificPopup.open({
        items: {
            src: '<div class="mfp-with-anim pp_qs" id="content_quickview">' + dt + '</div>',
            type: 'inline'
        },
        tClose: nt_settings.close,
        removalDelay: 500,
        callbacks: {
            beforeOpen: function() {
                this.st.mainClass = 'mfp-move-vertical'
            },
            open: function() {
                btn.addClass('pp_t4_opended');
                var el = $('.nt_carousel_qs'),
                    option = el.attr("data-flickity") || '{}';
                el.flickity(JSON.parse(option));
                body.addClass('open_ntqs');
                if (sp_nt_storage && bl) {
                    sessionStorage.setItem('qs' + ntid, dt)
                }
                btn.removeClass('loading');
                geckoShopify.DropdownPicker();
                geckoShopify.review();
                if ($('#content_quickview .buy_qs_true').length > 0) {
                    Shopify.PaymentButton.init()
                }
                if ($('#store_availability_qs').attr('data-has-only-default-variant') === 'true') {
                    geckoShopify._updateStoreAvailabilityContent($('#store_availability_qs'), true, $('#store_availability_qs').attr('data-vid'))
                }
                $('#content_quickview .lazypreload.nt_pre_img').addClass('lazyload');
                if (!$('#ProductJson-template_qs').html()) {
                    return
                }
                var productJson = JSON.parse($('#ProductJson-template_qs').html()),
                    incomingJson = JSON.parse($('#ProductJson-incoming_qs').html()),
                    IdSelect = '#product-select_qs',
                    NtId = '#nt_select_qs_',
                    selector = '#cart-form_qs',
                    callBackVariant = '#callBackVariant_qs',
                    prefix = '_qs',
                    i, variant, Arr_MD = [];
                productJson.ck_so_un = incomingJson.ck_so_un;
                productJson.ntsoldout = incomingJson.ntsoldout;
                productJson.unvariants = incomingJson.unvariants;
                productJson.remove_soldout = incomingJson.remove_soldout;
                productJson.size_avai = incomingJson.size_avai;
                productJson.tt_size_avai = incomingJson.tt_size_avai;
                for (i in incomingJson.variants) {
                    variant = incomingJson.variants[i];
                    productJson.variants[i].incoming = variant.incoming;
                    productJson.variants[i].next_incoming_date = variant.next_incoming_date;
                    productJson.variants[i].inventory_quantity = variant.inventory_quantity;
                    Arr_MD.push(variant.mdid)
                }
                geckoShopify.Ntproduct_switch('.variations_form_qs', Arr_MD, productJson, selector, IdSelect, NtId, callBackVariant, prefix);
                if (nt_settings.pr_curent !== "1" || $('#cart-form_qs .is-selected-nt').length > 0) {
                    $('#nt_select_qs_1 .is-selected-nt, #nt_select_qs_2 .is-selected-nt').addClass('is-selected').removeClass('is-selected-nt');
                    $('#nt_select_qs_0 .is-selected-nt').click().removeClass('is-selected-nt');
                    if (!nt_settings.use_vimg) return;
                    $('#nt_select_qs_1 .is-selected,#nt_select_qs_2 .is-selected').removeClass('is-selected').click()
                }
            },
            beforeClose: function() {
                if ($('.store_availabilities_modal.act_opened').length > 0) {
                    $('.store_availabilities_modal .close_pp').trigger('click')
                }
            },
            close: function() {
                $('.' + clicked_ed_js).removeClass(clicked_ed_js);
                $('#content_quickview').empty();
                body.trigger('refresh_hreft4');
                btn.removeClass('pp_t4_opended');
                body.removeClass('open_ntqs');
                geckoShopify.DropdownPicker()
            }
        },
      })
    },
    setLang () {
      const languageCode = (Shopify.routes.root != '/' && Shopify.locale != 'en') ? Shopify.locale : '';
      $('.boost-pfs-filter-tree-mobile-button button').addClass(languageCode)
    }
  }
  
  
  handleCollectionItem.init()
  
  $(document).on('click','.custom_collection_btn',function(event){
    handleCollectionItem.showPop($(this))
  })

  $(document).on('click',' .boost-pfs-filter-option-title',function(event){
    let isActive = $(this).hasClass('active')
    let isToggle = $(this).siblings('.boost-pfs-filter-option-content').hasClass('toggled')
    if (!isActive && !isToggle) {
      $(this).addClass('active')
      $(this).siblings('.boost-pfs-filter-option-content').show()
    } else {
      $('.boost-pfs-filter-option-title').removeClass('active')
      $('.boost-pfs-filter-option-content').hide()
    }
  })
  // $(document).on('click','.template-collection .boost-pfs-filter-option-title',function(event){
  //   let isActive = $(this).hasClass('active')
  //   $('.boost-pfs-filter-option-title').removeClass('active')
  //   $('.boost-pfs-filter-option-content').hide()
  //   if (!isActive) {
  //     $(this).addClass('active')
  //     $(this).siblings('.boost-pfs-filter-option-content').show()
  //   }
  // })
